module.exports = __webpack_public_path__ + "img/stamp.bc7d4042.png";